import { API_REQUEST } from '../../core/actions';
import * as notificationsApi from '../../core/api/notifications';

export const CREATE_NOTIFICATION = 'CREATE_NOTIFICATION';
export const UPDATE_NOTIFICATION = 'UPDATE_NOTIFICATION';
export const FETCH_NOTIFICATIONS = 'FETCH_NOTIFICATIONS';
export const FETCH_FOLLOWUP_NOTIFICATIONS = 'FETCH_FOLLOWUP_NOTIFICATIONS';
export const FETCH_STALLED_CLAIM_NOTIFICATIONS = 'FETCH_STALLED_CLAIM_NOTIFICATIONS';
export const FETCH_CLAIM_EMAIL_APPROVAL_NOTIFICATIONS = 'FETCH_CLAIM_EMAIL_APPROVAL_NOTIFICATIONS';
export const FETCH_CLAIM_CREATED_NOTIFICATIONS = 'FETCH_CLAIM_CREATED_NOTIFICATIONS';
export const UPDATE_NOTIFICATION_TRACKING = 'UPDATE_NOTIFICATION_TRACKING';
export const WHATS_NEW_NOTIFICATION_TYPE = 'WHATS_NEW';
export const FOLLOW_UP_NOTIFICATION_TYPE = 'followup';
export const STALLED_CLAIM_NOTIFICATION_TYPE = 'claim_not_approved_or_denied_week';
export const CLAIM_EMAIL_APPROVAL_NOTIFICATION_TYPE = 'claim_email_approval_needed';
export const CLAIM_CREATED_NOTIFICATION_TYPE = 'claim_created';

interface ShareWhatsNewPayload {
  title: string;
  body: string;
  type: string;
  link?: string | null;
  media?: Array<Record<string, any>>;
  showOnLogin?: boolean;
  sendToAllSites?: boolean;
  siteIds?: Array<number | string>;
}

interface UpdateWhatsNewPayload extends ShareWhatsNewPayload {
  id: number;
}

export const fetchNotifications = (query: Record<string, any> = {}) => ({
  type: API_REQUEST,
  callAPI: notificationsApi.fetchNotifications,
  data: { query },
  action: FETCH_NOTIFICATIONS,
});

export const fetchFollowUpNotifications = (query: Record<string, any> = {}) => ({
  type: API_REQUEST,
  callAPI: notificationsApi.fetchNotifications,
  data: { query },
  action: FETCH_FOLLOWUP_NOTIFICATIONS,
});

export const fetchStalledClaimNotifications = (query: Record<string, any> = {}) => ({
  type: API_REQUEST,
  callAPI: notificationsApi.fetchNotifications,
  data: { query },
  action: FETCH_STALLED_CLAIM_NOTIFICATIONS,
});

export const fetchClaimEmailApprovalNotifications = (query: Record<string, any> = {}) => ({
  type: API_REQUEST,
  callAPI: notificationsApi.fetchNotifications,
  data: { query },
  action: FETCH_CLAIM_EMAIL_APPROVAL_NOTIFICATIONS,
});

export const fetchClaimCreatedNotifications = (query: Record<string, any> = {}) => ({
  type: API_REQUEST,
  callAPI: notificationsApi.fetchNotifications,
  data: { query },
  action: FETCH_CLAIM_CREATED_NOTIFICATIONS,
});

export const shareWhatsNewUpdate = (
  payload: ShareWhatsNewPayload,
  options: { callback?: () => any } = {}
) => ({
  type: API_REQUEST,
  callAPI: notificationsApi.createNotification,
  data: payload,
  action: CREATE_NOTIFICATION,
  closeModal: true,
  callback: options.callback,
});

export const updateWhatsNewNotification = (
  payload: UpdateWhatsNewPayload,
  options: { callback?: () => any } = {}
) => ({
  type: API_REQUEST,
  callAPI: notificationsApi.updateNotification,
  data: payload,
  action: UPDATE_NOTIFICATION,
  closeModal: true,
  callback: options.callback,
});

interface MarkNotificationReadPayload {
  notificationId: number;
  trackingId: number;
  read?: boolean;
}

export const markNotificationRead = (
  payload: MarkNotificationReadPayload,
  options: { callback?: () => any } = {}
) => ({
  type: API_REQUEST,
  callAPI: notificationsApi.updateNotificationTracking,
  data: payload,
  action: UPDATE_NOTIFICATION_TRACKING,
  callback: options.callback,
});
